import { createFileRoute } from '@tanstack/react-router';
import { useMinWidth } from '@tupai/shell';
import ChildActivityPage from '@/components/child-activity-page';
import ChildHubPage from '@/components/child-hub-page';

// From `lg` the same URL renders the hub with its activity drawer open.
export const Route = createFileRoute('/_protected/children/$linkId/activity')({
  component: ChildActivityRoute,
});

function ChildActivityRoute() {
  const isLg = useMinWidth('lg');
  return isLg ? <ChildHubPage activityOpen /> : <ChildActivityPage />;
}
